import { ILoadingCellRenderer } from '@ag-grid-community/core';
var AdvancedTableCustomLoadingComponent = /** @class */ (function () {
    function AdvancedTableCustomLoadingComponent() {
    }
    AdvancedTableCustomLoadingComponent.prototype.agInit = function (params) {
        console.log(params);
        this.params = params;
    };
    return AdvancedTableCustomLoadingComponent;
}());
export { AdvancedTableCustomLoadingComponent };
